// Only known internal member destinations may survive login. Guards still enforce role/status.
export const safeLoginReturn = (value: unknown): string => {
  if (
    typeof value !== 'string' ||
    !/^\/(news(?:\/[A-Za-z0-9_-]+)?|members(?:\/[A-Za-z0-9_-]+)?|account\/(?:profile|subscription))(?:\?comments=1)?$/.test(value)
  )
    return '/'
  return value
}
